import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function MayaSQRSolution({ navigation, primaryDetails, setPrimaryDetails }) {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
    // Clear error for this field when user starts typing/selecting
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const validate = () => {
    const newErrors = {
      sqr_solution: !primaryDetails.sqr_solution,
    };

    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);
    
    if (hasErrors) {
      toast.error("Please select an option for Maya SQR solution", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
   

    if (validate()) {
      if (primaryDetails.sqr_solution === 'Yes') {
        navigation.go('maya-sqr-solution-details');
      } else if (primaryDetails.sqr_solution === 'No') {
        // navigation.go('qrph-knowledge');
        navigation.go('maya-black');
      }
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Maya SQR Solution</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">

              <Form>

                {/* Maya SQR Solution */}
                <Form.Group className={`mb-4 ${errors.sqr_solution ? 'form-group-error' : ''}`}>
                  <Form.Label className="form-label">
                    Maya Static QR (SQR) Solution <span className="form-required">*</span>
                  </Form.Label>
                  <div className="form-radio-group">
                    <div className={`form-radio-item${primaryDetails.sqr_solution === 'Yes' ? " selected" : ""}`}>
                      <div className="form-radio-flex">
                        <Form.Check
                          type="radio"
                          name="sqr_solution"
                          value="Yes"
                          label="Has Maya SQR"
                          onChange={handleChange}
                          checked={primaryDetails.sqr_solution === 'Yes'}
                          className="form-radio"
                        />
                      </div>
                    </div>
                    <div className={`form-radio-item${primaryDetails.sqr_solution === 'No' ? " selected" : ""}`}>
                      <div className="form-radio-flex">
                        <Form.Check
                          type="radio"
                          name="sqr_solution"
                          value="No"
                          label="No Maya SQR"
                          onChange={handleChange}
                          checked={primaryDetails.sqr_solution === 'No'}
                          className="form-radio"
                        />
                      </div>
                    </div>
                  </div>
                  {errors.sqr_solution && (
                    <div className="form-error">
                      Required
                    </div>
                  )}
                </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                    Next →
                  </AppButton>
                </div>
              </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MayaSQRSolution;
